module.exports = __webpack_public_path__ + "img/pr-1.8f7dc9cc.png";